import React from 'react'

import Avatar from 'components/common/Avatar'
import Text from 'components/common/Text'

import { Container, AvatarWrapper } from './styles'

const TeacherPlaceholder = ({ isArtefactMode = false }) => {
    return (
        <Container isArtefactMode={isArtefactMode}>
            <AvatarWrapper>
                <Avatar userType="teacher" />
            </AvatarWrapper>
            <Text level="5" bold={false} color="rgba(255, 255, 255, 0.56)">
                Teacher will be joining soon....
            </Text>
        </Container>
    )
}

export default TeacherPlaceholder
